var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgApproveDelagation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_576_2913",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 25
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_576_2913)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.925 11.55L8.675 7.30001L10.1 5.90001L12.925 8.72501L18.6 3.07501L20 4.47501L12.925 11.55ZM7 19L13.95 20.9L19.9 19.05C19.8167 18.9 19.6958 18.7708 19.5375 18.6625C19.3792 18.5542 19.2 18.5 19 18.5H13.95C13.5 18.5 13.1417 18.4833 12.875 18.45C12.6083 18.4167 12.3333 18.35 12.05 18.25L9.725 17.475L10.275 15.525L12.3 16.2C12.5833 16.2833 12.9167 16.35 13.3 16.4C13.6833 16.45 14.25 16.4833 15 16.5C15 16.3167 14.9458 16.1417 14.8375 15.975C14.7292 15.8083 14.6 15.7 14.45 15.65L8.6 13.5H7V19ZM1 22.5V11.5H8.6C8.71667 11.5 8.83333 11.5125 8.95 11.5375C9.06667 11.5625 9.175 11.5917 9.275 11.625L15.15 13.8C15.7 14 16.1458 14.35 16.4875 14.85C16.8292 15.35 17 15.9 17 16.5H19C19.8333 16.5 20.5417 16.775 21.125 17.325C21.7083 17.875 22 18.6 22 19.5V20.5L14 23L7 21.05V22.5H1ZM3 20.5H5V13.5H3V20.5Z",
    fill: "#1C1C1C"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApproveDelagation);
export default __webpack_public_path__ + "static/media/approveDelagation.6bcae45c3a15bc0f1b2182566b8b88e5.svg";
export { ForwardRef as ReactComponent };